import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21.21 15.89A10 10 0 1 1 8 2.83", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 12A10 10 0 0 0 12 2v10z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PieChart";
const PieChart = memo(themed(Icon));
export {
  PieChart
};
//# sourceMappingURL=pie-chart.js.map
